import React, { createContext, useContext, useState } from 'react';

const ProgressBarContext = createContext();

export const useProgressBar = () => {
  return useContext(ProgressBarContext);
};

export const ProgressBarProvider = ({ children }) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const showProgressBar = () => setIsVisible(true);
  const hideProgressBar = () => {
    setIsVisible(false);
    setProgress(0); // Reset progress when hidden
  };
  const updateProgressBar = (percentage) => setProgress(percentage);

  return (
    <ProgressBarContext.Provider
      value={{ progress, isVisible, showProgressBar, hideProgressBar, updateProgressBar }}
    >
      {children}
    </ProgressBarContext.Provider>
  );
};
